import '../css/landing.css';
import main from '../assets/BTSwami_About/community.jpeg';
import main2 from '../assets/BT_SWAMI_Portraits/BTSwami-KuntiMadhava.jpg';
import btswami from '../assets/BT_SWAMI_Portraits/BTSwami_home.jpg';
import { useNavigate } from 'react-router-dom';
import Books from './Books';

export default function Landing() {
  const navigate = useNavigate();

  return (
    <div className="page-width">
      {/* Section 1 */}
      <div className="landing">
        <div className="left">
          <div className="titles">
            <div className="caption2">
              <p>Who are we ?</p>
            </div>
            <div className="caption3">
              <p>
                The Institute for Applied Spiritual Technology (IFAST) was
                founded in Washington, D.C. in 1988 by His Holiness Bhakti
                Tirtha Swami. IFAST aims to provide spiritual training and
                education through a variety of spiritual paths and professional
                backgrounds.
              </p>
            </div>
          </div>
        </div>

        <div className="right">
          <img
            className="fading-image-about"
            src={main}
            alt="iFAST community"
          />
        </div>
      </div>

      {/* Section 2 */}
      <div className="landing">

        <div className="left">
          <div className="titles">
            <div className="caption2">
              <p>His Holiness Bhakti Tirtha Swami</p>
            </div>
            <div className="caption3">
              <p>
                B.T Swami, a renowned Vedic psychologist, scientist,
                philosopher, and a Governing Body Commissioner within the
                International Society for Krishna Consciousness (ISKCON)
              </p>
            </div>
            <div className="btns">
              <button
                onClick={() => navigate('/about-bhakti-tirtha-swami')}
                type="button"
                className="spiritual-button"
              >
                Know More
              </button>
            </div>
          </div>
        </div>
        <div className="right">
          <img
            className="fading-image-about"
            src={btswami}
            alt="Bhakti Tirtha Swami"
          />
        </div>
      </div>

      {/* Section 3 */}
      <div className="landing">
        <div className="left">
          <div className="titles">
            <div className="caption2">
              <p>
                At <span>IFAST,</span> we work towards the betterment of our{' '}
                <span>world</span>
              </p>
            </div>
            <div className="caption3">
              <p>
                Ifast DC is a diverse community consisting of men and women from various walks of life and wide variety of spiritual perspectives who are attracted by the concept of Bhakti, which means, manifesting our innate divine love through connection with the Source of Love.
                We aim to provide an engaging, practical, and holistic
                approach to spiritual education by incorporating interactive
                methods, enjoyable activities, practical teachings, and a focus
                on spiritual growth. It is designed to equip individuals with
                the tools and knowledge to deepen their understanding of holy
                scriptures, spiritual practices, and the philosophy of God
                consciousness, fostering personal growth, spiritual
                development, and ultimately transformation of ourselves and our world.
              </p>
            </div>
          </div>
        </div>

        <div className="right">
          <img
            className="fading-image-about"
            src={main2}
            alt="iFAST spiritual gathering"
          />
        </div>
      </div>
      <Books/>
    </div>
  );
}
